var map = {
	"./18-days-voyage.jpg": "d326",
	"./architecturals.jpg": "f95d",
	"./behind-the-waves.jpg": "0ad5",
	"./calm-waters.jpg": "d23b",
	"./cityscapes.jpg": "bea9",
	"./dark-forest.jpg": "82fe",
	"./king-on-africa.jpg": "8d41",
	"./land-of-dreams.jpg": "d948",
	"./milky-way.jpg": "b3c1",
	"./moon-of-appalacia.jpg": "7a4e",
	"./mountains.jpg": "e30f",
	"./rage-of-the-sea.jpg": "45a6",
	"./running-free.jpg": "14fd",
	"./somwarpet.jpg": "ab3e",
	"./trip-to-nowhere.jpg": "56e3",
	"./unforeseen-corners.jpg": "1bb4",
	"./world-tour.jpg": "6fc1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1c26";